// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__J2dAn","link":"HeaderSimple_link__cXGFy","linkSmall":"HeaderSimple_linkSmall__PFS2K","inputSearch":"HeaderSimple_inputSearch__Cdyzs"};